export function main_service() {
  const hostname = window.location.hostname
  switch (hostname) {
    case "localhost":
      return "//localhost:8080"
    default:
      return `//${hostname.split('.').slice(1).join('.')}`
  }
}